import { pick } from "lodash";
import type TechnologySignalFilters from "app/pages/sales-intelligence/sub-modules/signals/models/technology/TechnologySignalFilters";
import type TechnologySignalTechnologiesFilters from "app/pages/sales-intelligence/sub-modules/signals/models/technology/TechnologySignalTechnologiesFilters";
import { TechnologySignalAllFiltersKey } from "app/pages/sales-intelligence/sub-modules/signals/models/technology/TechnologySignalTechnologiesFiltersKey";

export const getTechnologiesFiltersValue = (
    filters: Readonly<Partial<TechnologySignalFilters>>,
): Readonly<Partial<TechnologySignalTechnologiesFilters>> => {
    const technologiesFiltersKeys = Object.values(TechnologySignalAllFiltersKey);

    return pick(filters, technologiesFiltersKeys);
};
